import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const entMonedasApi = `${baseUrl}/entidad-monedas`;

export const allEntMonedasService = async (params) => {
  const res = await axios.get(entMonedasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEntMonedasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${entMonedasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(entMonedasApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEntMonedasService = async (id) => {
  const res = await axios.get(`${entMonedasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEntMonedasService = async (id) => {
  const res = await axios.delete(`${entMonedasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
